




















































import { Vue, Component } from "vue-property-decorator";
@Component({
  name: "l-header"
})
export default class LHeaderComponent extends Vue {
  goHome() {
    this.$router.push("/");
  }
  isPanel() {
    return this.$route.meta.panelTitle != null;
  }
  showNavigationPanel() {
    // debugger
    // проверять если нет навигационной панели то не генерировать событие

    this.$emit("shownav");
  }
  showMenu() {
    this.$emit("showMenu");
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/layouts/l-header.vue